import {Pipe, PipeTransform} from "@angular/core";

/**
 * Returns
 * - the first occurence of an element in an Array if not empty,
 * - the first element and ,... if more than one elements exist
 * - null if no or only empty elements are present
 */
@Pipe({
  name: 'arrayAbbreviate'
})
export class ArrayAbbreviatePipe implements PipeTransform {

  /**
   * @param {Array<any>} values
   * @param {string} abrevMarker    E.g. '...'
   * @param valueAccessorFunction   Use this if value contains a property which shall be displayed. Otherwise use x => return x;
   * @returns {string}              E.g. 'Wohnrecht,...'
   */
  transform(values: Array<any>, abrevMarker: string, valueAccessorFunction): string {
    if (!values || values.length === 0 || !values[0]) {
      return '';
    }
    const objectVal = valueAccessorFunction(values[0]);
    if (objectVal) {
      return (values.length > 1) ? objectVal + "," + abrevMarker : objectVal;
    }
    return '';
  }

}
